module.exports = __webpack_public_path__ + "img/default_logo.9d6b93fd.png";